import BaseApi from './BaseApi';

class EventsApi extends BaseApi {
    get(query = null) {
        return this.requestGet(this.route('events.index'), query, {
            withCredentials: true,
            withLocale: true,
        });
    }
}

export default EventsApi;
